import { Loader2, Sparkles } from "lucide-react";
import { DetailSection } from "@/components/AIAnalysisCard";
import { BeforeAfter } from "@/components/BeforeAfter";
import { fileUrl } from "@/lib/api";

const SKIP_REASONS = {
  monthly_limit: "Not generated: the monthly limit of 30 previews was reached.",
  ip_limit: "Not generated: daily limit for this homeowner's network was reached.",
  disabled: "Not generated: previews were turned off in Settings.",
};

const Choices = ({ preview }) => (
  <div className="mt-4 flex flex-wrap gap-1.5" data-testid="lead-preview-choices">
    <span className="rounded-full bg-muted px-2.5 py-1 text-xs font-medium text-foreground" data-testid="lead-preview-style">Style: {preview.style}</span>
    {Object.entries(preview.preferences || {}).map(([k, v]) => (
      <span key={k} className="rounded-full bg-muted px-2.5 py-1 text-xs font-medium text-foreground" data-testid="lead-preview-pref">{k}: {v}</span>
    ))}
  </div>
);

export const LeadPreview = ({ lead }) => {
  if (!lead.preview) return null;
  const s = lead.preview_status;
  return (
    <DetailSection icon={Sparkles} title="Finished-space preview" testId="lead-preview-section">
      {s === "done" ? <BeforeAfter before={fileUrl(lead.preview.photo_path)} after={fileUrl(lead.preview_path)} testId="lead-preview-compare" />
        : s === "pending" ? <p className="flex items-center gap-2 text-sm text-muted-foreground" data-testid="lead-preview-status"><Loader2 className="h-4 w-4 animate-spin" />Creating preview...</p>
        : <p className="text-sm text-muted-foreground" data-testid="lead-preview-status">{s === "skipped" ? SKIP_REASONS[lead.preview_error] || "Not generated." : "The preview couldn't be generated for this request."}</p>}
      <Choices preview={lead.preview} />
    </DetailSection>
  );
};
